export default __webpack_public_path__ + "static/media/check.857db4eb.svg";